var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandGesture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1474",
    "data-name": "Group 1474",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.339,
    height: 27.172,
    viewBox: "0 0 29.339 27.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1282",
    "data-name": "Rectangle 1282",
    width: 29.339,
    height: 27.172,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25718",
    "data-name": "Path 25718",
    d: "M59.978,5.657c-1.486-.379-2.21-.114-2.984,1.093a10.117,10.117,0,0,0-.521,2.015l-.026.226c.1.569-.08,1.153.069,1.714a2.448,2.448,0,0,1-.826,2.482,5.528,5.528,0,0,0-1.743,4.276c-.007.135.059.268,0,.4.007-.153-.022-.305-.025-.457A7.257,7.257,0,0,1,56,11.675c.4-.422.756-.868.252-1.455-.3-.006-.408-.266-.583-.439-2.662-2.628-4.763-5.723-7.139-8.59A2.373,2.373,0,0,0,45.826.119a1.723,1.723,0,0,0-.436,2.332,4.278,4.278,0,0,0,.3.56,7.925,7.925,0,0,0-1.261-1.428c-.442-.076-.586-.5-.873-.759A1.729,1.729,0,0,0,41.055.657,2.321,2.321,0,0,0,41.3,3.669c.892,1.194,1.731,2.427,2.647,3.6,1.4,1.787,2.736,3.658,4.94,4.665-.394.1-.438,1.259-1.056.389-1.833-2.579-4-4.9-5.8-7.5a3.98,3.98,0,0,0-1.841-1.637c-.367.121-.782.17-.938.613-.691,1.719.1,3.027,1.227,4.2a11.478,11.478,0,0,1,1.678,2.269,13.625,13.625,0,0,0,.952,1.441c-.4-.525-.805-1.041-1.237-1.537-.689-.793-1.237-1.834-2.413-2.1-.3.233-.812.134-.936.624a3.976,3.976,0,0,0,.388,2.232c1.145,1.9,2,3.972,3.3,5.774a33.025,33.025,0,0,0,8.113,8,6.087,6.087,0,0,0,5.77.927c2.556-.891,4.88-2.147,5.779-5A24.72,24.72,0,0,1,61,11.933a6.8,6.8,0,0,0-.212-2.257,7.571,7.571,0,0,1-.628-3.229c.024-.27.09-.578-.186-.791M46.616,4.409c-.229-.358-.457-.721-.7-1.077a6.043,6.043,0,0,0,.625.7A5.5,5.5,0,0,1,47.73,5.451a12.394,12.394,0,0,0,4.1,4.464c-.53.446-.915.6-1.279-.157A7.749,7.749,0,0,0,49.216,7.9a24.286,24.286,0,0,1-2.6-3.488m-.761,11.535c-.04.074-.062.132-.121.141a1.55,1.55,0,0,0-.386-1.293c-.712-.977-1.4-1.975-2.124-2.942a10.607,10.607,0,0,0,2.145,2.087c1.13.816,1.147.79.487,2.007",
    transform: "translate(-36.727 0)",
    fill: "#ffc90e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25719",
    "data-name": "Path 25719",
    d: "M167.187,2.544c-.7,1.331-.42,2.519.935,3.716a10.443,10.443,0,0,1,1.747,2.325,8.4,8.4,0,0,0,3.648,3.427,5.821,5.821,0,0,1,.571.342l-2.172,1c-.191-1.586-1.364-2.519-2.237-3.619A48.921,48.921,0,0,1,165.8,4.008a1.7,1.7,0,0,1,1.391-1.464",
    transform: "translate(-158.088 -2.426)",
    fill: "orange"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25720",
    "data-name": "Path 25720",
    d: "M498.947,125.693c-1.065-1.179-.977-2.592-.814-4.02.615.015.649.5.677.914.071,1.033.094,2.07.136,3.105",
    transform: "translate(-474.882 -116.017)",
    fill: "#ffd94a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25721",
    "data-name": "Path 25721",
    d: "M423.63,143.579c.139-.038.391-.221.247.153-.242.626-.51,1.241-.767,1.862a2.158,2.158,0,0,1,.521-2.015",
    transform: "translate(-403.363 -136.83)",
    fill: "orange"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25722",
    "data-name": "Path 25722",
    d: "M366.862,131.859a1.031,1.031,0,0,0,.046.376c.2.522-.06.849-.409,1.23-1.573,1.721-2.586,3.652-2.031,6.093a.974.974,0,0,0,.314,1.022c0-.381-.006-.679-.008-.977h0a6.336,6.336,0,0,1,2.048-4.526c.339-.345.93-.7.776-1.217,0,0-.3-3.973.709-5.9,0,0-1.727,1.035-1.445,3.895",
    transform: "translate(-347.378 -122.015)",
    fill: "orange"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25723",
    "data-name": "Path 25723",
    d: "M54.426,186.092c-1.04,2.7-3.31,3.91-5.846,4.72a4.758,4.758,0,0,1-4.032-.191,29.643,29.643,0,0,1-11.3-12.194,14.278,14.278,0,0,1-1.735-3.8,1.2,1.2,0,0,1,.768-1.166A1.46,1.46,0,0,0,30.994,175c0,.035,0,.07,0,.1,0,0,0,.008,0,.013h0a4.179,4.179,0,0,0,.348,1.45,25.058,25.058,0,0,0,3.355,5.842,23.622,23.622,0,0,0,6.036,6.37,13.9,13.9,0,0,1,3.326,2.772,2.616,2.616,0,0,0,2.4,1.005,11.289,11.289,0,0,0,6.636-2.727,3.823,3.823,0,0,0,1.611-3.807c-.1.023-.256.02-.276.072",
    transform: "translate(-29.549 -165.396)",
    fill: "orange"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25724",
    "data-name": "Path 25724",
    d: "M38.131,68.427s-1.478.022-1.753,2.017h0a2.519,2.519,0,0,0,.379,1.616c.218.415.428.833.641,1.25a28.512,28.512,0,0,1,4.528,5.411c.737,1.051,2.079,1.9,1.367,3.577.586-.752,1.039-1.485,1.521-2.2.2-.29.322-.522-.143-.624-1.5-.331-2.309-1.538-3.256-2.573-.843-.922-1.157-2.221-2.039-3.071a6.278,6.278,0,0,1-2.18-3.6,1.707,1.707,0,0,1,.933-1.8",
    transform: "translate(-34.665 -65.246)",
    fill: "orange"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25725",
    "data-name": "Path 25725",
    d: "M75.312,4.082A2,2,0,0,0,73.426,5.15a1.447,1.447,0,0,0-.119.245l-.008.016h0a3.819,3.819,0,0,0-.052,1.658,44.57,44.57,0,0,1,3.609,4.481,24.728,24.728,0,0,0,1.8,2.314,6.454,6.454,0,0,1,2.225,3.682c.446-.921,1.412-1.19,1.708-2.131a3.941,3.941,0,0,1-2.364-1.061c-2.151-1.923-3.591-4.4-5.387-6.6a3.353,3.353,0,0,1-.893-2.48,1.431,1.431,0,0,1,1.361-1.19",
    transform: "translate(-69.782 -3.888)",
    fill: "orange"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25726",
    "data-name": "Path 25726",
    d: "M464.125,38.622a13.739,13.739,0,0,1,5.16,7.987.265.265,0,0,0,.523-.031c.239-2.454-.109-6.947-5.452-8.422a.266.266,0,0,0-.231.467",
    transform: "translate(-442.448 -36.372)",
    fill: "#3faae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25727",
    "data-name": "Path 25727",
    d: "M542.245,24.727a13.884,13.884,0,0,1,3.747,5.545.17.17,0,0,0,.33-.061,6.378,6.378,0,0,0-3.89-5.763.17.17,0,0,0-.187.28",
    transform: "translate(-516.983 -23.295)",
    fill: "#61c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25728",
    "data-name": "Path 25728",
    d: "M39.385,374.7a15.661,15.661,0,0,1-7.613-7.716.3.3,0,0,0-.576.156c.3,2.794,1.735,7.728,8.039,8.134a.3.3,0,0,0,.15-.574",
    transform: "translate(-29.744 -349.748)",
    fill: "#3faae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25729",
    "data-name": "Path 25729",
    d: "M5.83,463.173a15.826,15.826,0,0,1-5.469-5.318A.193.193,0,0,0,.007,458a7.271,7.271,0,0,0,5.68,5.529.194.194,0,0,0,.144-.355",
    transform: "translate(0 -436.477)",
    fill: "#61c0ea"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandGesture);
export default __webpack_public_path__ + "static/media/handGesture.64cebb26b68291d8286075a6d8ae2409.svg";
export { ForwardRef as ReactComponent };